// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
    production: false,
    //url:  'http://localhost:8000',
    //url: 'https://backend.foodbot.ai',
   // url:'https://stage-backend.foodbot.ai',
    url:'https://stage.foodbot.ai',
    // url:'https://partner1-stage.foodbot.ai',
    appid: "247887775922817",
    secret: "ebf748646171ecdca341564b780815ae",
    prod: 'https://backend.foodbot.ai',
    uat: 'https://uat-backend.foodbot.ai',
    stage: 'https://stage-backend.foodbot.ai',
    local:  'http://localhost:8000',
    // local: 'https://backend.foodbot.ai',
     //local:'https://stage.foodbot.ai/apis',
    live_appid: "1306412152790503",
    live_secret: "0d358332043124cba6ec27eeeccaf82e",
    test_appid: "247887775922817",
    test_secret: "ebf748646171ecdca341564b780815ae",
    uat_appid: "2012739902313244",
    uat_secret: "9c37219166fcb960961b5853a2a8d667",
    pass: "foodbot",
    iv: "7061737323310000",
    factura_prod_url: "https://v33.facturacfdi.mx/WSTimbradoCFDIService?wsdl",
    factura_stage_config_testing:'{"end_point_url_Global":"http://dev33.facturacfdi.mx/wsprocesazip?wsdl"}',
    factura_stage_config: '{"rfc": "LAN7008173R5","user": "pruebasWS","serie": "EX","key_file": "https://res.cloudinary.com/http-foodbot-ai/raw/upload/v1562825451/stage/factura_certificates/CSD_Pruebas_CFDI_LAN7008173R5.key","password": "pruebasWS","cert_file": "https://res.cloudinary.com/http-foodbot-ai/raw/upload/v1562825450/stage/factura_certificates/CSD_Pruebas_CFDI_LAN7008173R5.cer","rest_logo": "https://res.cloudinary.com/http-foodbot-ai/image/upload/v1542007973/eytllie3jtj19tqirrpm.jpg","keypem_file": "https://res.cloudinary.com/http-foodbot-ai/raw/upload/v1562825451/stage/factura_certificates/CSD_Pruebas_CFDI_LAN7008173R5.key.pem","certpem_file": "https://res.cloudinary.com/http-foodbot-ai/raw/upload/v1562825450/stage/factura_certificates/CSD_Pruebas_CFDI_LAN7008173R5.cer.pem","rest_address": "AV. EJERCITO NACIONAL MEXICANO No.769TORRE B PISO 10COL. GRANADA,DELEG. MIGUEL HIDALGO,CIUDAD DE MÉXICO","end_point_url": "http://dev33.facturacfdi.mx/WSTimbradoCFDIService?wsdl","regimenFiscal": "601","rest_legalname": "OPERADORA Y ADMINISTRADORA DERESTAURANTES GIGANTE","default_formapago": "99"}',
    ablyKey: "zrS3-A.wMAbsg:7FF1ql_raBGJWnQ8",
    google_key: "AIzaSyClWlaSDF8bIfuoSX8g8FRnGXKPHgs90YU",
    authorization_key:'FCN2M4E-Y3J4TNS-HD07D04-YEQWTTC',
    uuid:'7b2a2a11-f0e4-4d57-8b40-7680f3afcd69',
    dashboardV2Url: 'https://stagev2.foodbot.ai'
  };



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/environments/environment.ts